import { Context, PaginatedResult, Paging } from '@prodcard/core'

export interface GeneratorTool {
  create(ctx: Context): Promise<void>
  update(ctx: Context): Promise<void>
  delete(ctx: Context): Promise<void>
}

export function getRandomItem<T>(arr: T[]): T | undefined {
  const i = Math.floor(Math.random() * arr.length)
  return i < arr.length ? arr[i] : undefined
}

export async function getRandomFromRepo<T>(
  find: (paging: Paging) => Promise<PaginatedResult<T>>,
): Promise<T | undefined> {
  const count = (await find({ count: 0 })).count
  const result = await find({ count: 1, from: Math.floor(Math.random() * count) })
  return result.items.length > 0 ? result.items[0] : undefined
}
